import React, { createContext, useContext, useState, useEffect } from "react";

const UserAuthContext = createContext(null);
const TOKEN_KEY = "xpro_user_token";
const USER_KEY = "xpro_user_data";
const API = process.env.REACT_APP_BACKEND_URL;

export function UserAuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setUser(null); return; }
    fetch(`${API}/api/auth/user-me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(async (res) => {
        if (!res.ok) { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); setUser(null); return; }
        const data = await res.json();
        setUser(data);
      })
      .catch(() => { setUser(null); });
  }, []);

  const login = (userData, token) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setUser(null);
  };

  const refreshUser = async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return;
    const res = await fetch(`${API}/api/auth/user-me`, { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setUser(await res.json());
  };

  return (
    <UserAuthContext.Provider value={{ user, login, logout, refreshUser, loading: user === undefined }}>
      {children}
    </UserAuthContext.Provider>
  );
}

export const useUserAuth = () => useContext(UserAuthContext);
export const getUserToken = () => localStorage.getItem(TOKEN_KEY);
